import Account from "../Features/Shared/Account/MyAccount";

const MyAccount = () => {

    return (
        <Account />
    )
};

export default MyAccount;